<template lang="pug">
  #signUp
    router-view
</template>

<script>
import store from '../../store';

export default {
  // 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'SicComponent',
  beforeRouteEnter(to, from, next) {
    // TODO
    store.dispatch('sic_stores_manager/getPersonnelStoresHandler')
      .then(() => {
        store.commit('toggleLoading', false);
        next();
      });
  }
};
</script>
